import { render, staticRenderFns } from "./newUpload.vue?vue&type=template&id=f2ae2680&scoped=true"
import script from "./newUpload.vue?vue&type=script&lang=js"
export * from "./newUpload.vue?vue&type=script&lang=js"
import style0 from "./newUpload.vue?vue&type=style&index=0&id=f2ae2680&prod&scoped=true&lang=less"
import style1 from "./newUpload.vue?vue&type=style&index=1&id=f2ae2680&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ae2680",
  null
  
)

export default component.exports